import React from 'react';
import Icon from '../../../../../../../../../../../Icon/Icon';

import { QUOTA_UNITS } from '../../../../../../../../../../../../helpers/constants';

import styles from './AnswerQuota.module.css';

export default ({ choice, actions, questionId }) => (
  <div className={styles.container}>
    <div className={styles.dropdownRow}>
      <div className={styles.dropdownRowParent}>
        <Icon type="ljArrow" className={styles.ljArrow} />
        Close path after
        <input
          className={styles.quotaInput}
          value={choice.quotaAmount || ''}
          onChange={e => {
            const newChoice = choice;
            newChoice.quotaAmount = parseInt(e.currentTarget.value, 10);
            newChoice.quotaType = QUOTA_UNITS.ABSOLUTE;
            actions.updateQuestionChoice(questionId, newChoice);
          }}
          type="number"
          onKeyDown={evt => {
            if (
              evt.keyCode &&
              ((evt.keyCode >= 48 && evt.keyCode <= 57) ||
                evt.keyCode === 8 ||
                (evt.keyCode >= 96 && evt.keyCode <= 105))
            ) {
              return null;
            }
            return evt.preventDefault();
          }}
        />
        <span className={styles.dropdownContainerLabel}>#</span>
      </div>
      <span
        role="presentation"
        className={styles.close}
        onClick={() => {
          const newChoice = choice;
          newChoice.quotaAmount = null;
          newChoice.quotaType = null;
          actions.updateQuestionChoice(questionId, newChoice);
        }}
      >
        <Icon type="x" />
      </span>
    </div>
  </div>
);
